import AddRoleFormView from "../addroleformview/addroleformview";
import { AddRoleFormViewProps } from "../../addroleform.types";

const AddRoleFormGlossaryTab = (props: AddRoleFormViewProps): JSX.Element => {
  return <AddRoleFormView {...props} />;
};

export default AddRoleFormGlossaryTab;
